"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_media_variant_key = exports.build_original_media_key = exports.mediaKeySchema = exports.mediaIdSchema = exports.uploadIntentSchema = exports.mediaTypeSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.mediaTypeSchema = zod_1.default.enum(["avatar", "big_winner", "cover_image"]);
exports.uploadIntentSchema = zod_1.default.object({
    type: exports.mediaTypeSchema,
    contentType: zod_1.default.string().min(1).max(25),
});
exports.mediaIdSchema = zod_1.default.string().length(11);
exports.mediaKeySchema = zod_1.default.string().min(1).max(50);
function build_original_media_key(publicId, origExt) {
    return `${publicId}_orig.${origExt}`;
}
exports.build_original_media_key = build_original_media_key;
function build_media_variant_key(publicId, size, ext) {
    return `${publicId}_${size}.${ext}`;
}
exports.build_media_variant_key = build_media_variant_key;
